// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"32":"e4ff6c4339fac2ef99f8","149":"5c505684e08c6f7276f7","307":"f95a2d350858a004cfde","642":"03d314f1ee6efe50cc43","715":"31ea02b211d764a139f0","967":"02eb7565d4ab336f481c"}[chunkId] + ".hashedasset.js";
};